import {
  combine, createEvent, createStore, sample
} from 'effector';
import { createGate } from 'effector-react';
import { getCurrentUserStatusFxTrigger } from 'src/entity/HeroesVkStatus';
import { messagesTypes, setMessage } from 'src/entity/Messages';
import { $userAccessToken } from 'src/entity/User';
import { setImageStatusFx } from '../lib/effects/setImageStatusFx';

export const SetImageStatusGate = createGate();

export const setImageStatusId = createEvent<number>();
const $imageStatusId = createStore<number | null>(null);

const $combinedArgs = combine({
  $userAccessToken,
  imageStatusId: $imageStatusId
});

sample({
  clock: setImageStatusId,
  target: $imageStatusId
});

sample({
  clock: $imageStatusId,
  source: $combinedArgs,
  target: setImageStatusFx
});

sample({
  clock: setImageStatusFx.doneData,
  target: getCurrentUserStatusFxTrigger
});

sample({
  clock: setImageStatusFx.doneData,
  fn: () => messagesTypes.SET_IMAGE_STATUS_SUCCESS,
  target: setMessage
});

sample({
  clock: setImageStatusFx.failData,
  fn: () => messagesTypes.SET_IMAGE_STATUS_ERROR,
  target: setMessage
});
